export const isNotLoginRequired = (pathname: string) =>
  ["/login", "/reset-password", "/reset-password-new", "/session-expired"].some(row => pathname.startsWith(row)) ||
  pathname === "/email-change/confirm" ||
  pathname === "/email-change/revert";
